import { ChartDataAdapter } from 'src/components/BeaconV2Components/ExperimentalLayout/ContentV3/components/Summary/Visualizations/adapters/types';
import { TimeSeriesData, TimeSeriesPoint } from './TimeSeriesData';
import { ComparisonPeriod } from 'src/utils/Hooks';

interface TimeSeriesAdapterData {
  primaryMetrics: TimeSeriesPoint[];
  secondaryMetrics: TimeSeriesPoint[];
}
export class TimeSeriesAdapter implements ChartDataAdapter<TimeSeriesAdapterData> {
  private primaryData: TimeSeriesData;

  private comparisonData: TimeSeriesData;

  private comparisonPeriod: string;

  constructor(primaryData: TimeSeriesData, comparisonData: TimeSeriesData, comparisonPeriod: string) {
    // Defensive copies to prevent mutation
    this.primaryData = primaryData.clone();
    this.comparisonData = comparisonData.clone();
    this.comparisonPeriod = comparisonPeriod;
  }

  public connectSeries(): TimeSeriesAdapter {
    if (!this.comparisonData.isValid()) {
      return this;
    }

    const lastComparisonPoint = this.comparisonData.getLastElement();
    const splicedData = this.primaryData.unshift(lastComparisonPoint);

    this.primaryData = splicedData;
    return this;
  }

  public convertTimeStampsToNextYear(): TimeSeriesAdapter {
    this.comparisonData = this.comparisonData.convertTimeToNextYear();
    return this;
  }

  public transform(): TimeSeriesAdapterData {
    if (this.comparisonPeriod === ComparisonPeriod.PRIOR_PERIOD) {
      this.connectSeries();
    } else if (this.comparisonPeriod === ComparisonPeriod.PRIOR_YEAR) {
      this.convertTimeStampsToNextYear();
    }

    return {
      primaryMetrics: this.primaryData.toChartSeries(),
      secondaryMetrics: this.comparisonData.toChartSeries()
    };
  }
}
